var React = require('react');

function X (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.9207 2.00012H15.127L10.3082 7.50637L15.977 15.0001H11.5395L8.06133 10.4564L4.08633 15.0001H1.87695L7.03008 9.1095L1.5957 2.00012H6.1457L9.28633 6.15325L12.9207 2.00012ZM12.1457 13.6814H13.3676L5.48008 3.25012H4.16758L12.1457 13.6814Z"}));
}

X.defaultProps = {"width":"32","height":"32","viewBox":"0 0 17 16","fill":"none"};

module.exports = X;

X.default = X;
